import { gql } from "@apollo/client"

let API

const getProducts = function(countryCode) {
  return API.Default.query({
    query: gql`
      query BleachSite_GetAllProducts__cached($countryCode: String!) {
        productBundles(regionCode: $countryCode) {
          id
          cmsId
          quantityStatus
          description
          displayTitle
          ecomId
          ecomVariantHandler
          ecomVariantId
          products {
            cmsId
          }
          slug
          productGroup {
            cmsId
          }
          price {
            cents
            currency
          }
          compareAtPrice {
            cents
            currency
          }
          sku
          sellingPlanGroups {
            sellingPlans {
              shopifyGid
              orderIntervalUnitType
              orderIntervalFrequency
              pricingPolicy {
                adjustmentValue
              }
            }
          }
        }
        giftCards(regionCode: $countryCode) {
          id
          cmsId
          ecomVariantHandler
          ecomVariantId
          description
          price {
            cents
            currency
          }
          displayTitle
          sku
          slug
        }
        products(regionCode: $countryCode) {
          id
          cmsId
          description
          displayTitle
          slug
          ecomId
          ecomVariantId
          ecomVariantHandler
          quantityStatus
          averageRating
          numberOfReviews
          price {
            cents
            currency
          }
          compareAtPrice {
            cents
            currency
          }
          sku
          sellingPlanGroups {
            sellingPlans {
              shopifyGid
              orderIntervalUnitType
              orderIntervalFrequency
              pricingPolicy {
                adjustmentValue
              }
            }
          }
        }
      }
    `,
    variables: {
      countryCode: countryCode
    }
  })
    .then(res => {
      return {
        products: mapProducts(res.data.products),
        giftCards: mapProducts(res.data.giftCards),
        bundles: mapProducts(res.data.productBundles)
      }
    })
    .catch(error => {
      console.log(error)
    })
}

export default {
  init: _API => {
    API = _API
  },
  methods: {
    getProducts
  }
}

/////////////////////
/////// UTILS ///////
/////////////////////

function mapProducts(products) {
  return products
    .filter(product => !!product)
    .map(product => {
      // Map BleachAPI reference field objects to match Contentful GQL shape
      let _mappedReferenceFields = {}
      Object.keys(product).forEach(key => {
        // Do it for simple references
        if (product[key] && product[key].cmsId) {
          _mappedReferenceFields[key] = {
            sys: {
              id: product[key].cmsId
            }
          }
        }
        // And for arrays of references
        else if (product[key] && Array.isArray(product[key])) {
          let _arr = []
          product[key].forEach(item => {
            if (item) {
              if (item.cmsId) {
                _arr.push({
                  sys: {
                    id: item.cmsId
                  }
                })
              } else {
                _arr.push(item)
              }
            }
          })
          _mappedReferenceFields[key] = _arr
        }
      })
      return {
        ...product,
        ..._mappedReferenceFields
      }
    })
}
